export function getSubTable(phpFile) {

    return function(dispatch) {
        fetch(phpFile)
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "SUBTABLE",
                    payload: data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "SUBTABLE",
                    payload: error
                })
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/getSubTable.js